var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit, Model } from "vue-property-decorator";
import ExpressionBase from "./expression-base.vue";
import { ValidatorService } from "~/utils/validator.service";
import { FilterService } from '~/utils/filter.service';
var ConfigBase = /** @class */ (function (_super) {
    __extends(ConfigBase, _super);
    function ConfigBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cdate1 = "";
        _this.cdate2 = "";
        _this.cdate3 = "";
        _this.dateArr = [];
        _this.showpopover = false;
        _this.priorityList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.rules = {
            name: { required: true, message: "请输入策略名称" },
            strategyStatus: { required: true, message: "请选择策略状态" },
            startDate: { required: true, message: "请选择开始时间" },
            endDate: { required: true, message: "请选择结束时间" },
            intervals: [{ required: true, message: "请输入间隔时间" }, { pattern: /^[1-9][0-9]*$/, message: '时间间隔只能为大于0的正整数' }],
            timeType: { required: true, message: "请选择间隔时间类型" },
            executionFrequency: { required: true, message: "请选择执行频率" }
        };
        return _this;
    }
    Object.defineProperty(ConfigBase.prototype, "strategyDataSet", {
        get: function () {
            if (!this.model.formulaJson)
                return [];
            return JSON.parse(this.model.formulaJson);
        },
        set: function (value) {
            this.model.formulaJson = JSON.stringify(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigBase.prototype, "getIsDisabled", {
        get: function () {
            return !!(!this.model.casePoolTypes.length || (this.model.casePoolTypes.length && this.model.casePoolTypes.find(function (v) { return v === 'WAIT_DISTRIBUTION' || v === 'RECOVERED_DISTRIBUTION'; })));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConfigBase.prototype, "isDisabled", {
        get: function () {
            return !!(!this.model.casePoolTypes.length || this.model.casePoolTypes.find(function (v) { return v !== 'WAIT_DISTRIBUTION' && v !== 'RECOVERED_DISTRIBUTION'; }));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 验证基础配置数据r
     */
    ConfigBase.prototype.validate = function () {
        var _this = this;
        var form = this.$refs.form;
        return Promise.all([form.validate(), this.validateExpression(), this.validateBreaketComplete()])
            .then(function () { return _this.emitBaseChange(_this.model); })
            .catch(function () { return Promise.reject('config-base'); });
    };
    ConfigBase.prototype.emitBaseChange = function (v) { };
    ConfigBase.prototype.casePool = function () {
        if (!this.model.casePoolTypes.length) {
            this.$message('请选择取数案件池!');
            return false;
        }
    };
    ConfigBase.prototype.formValidate = function () {
        var form = this.$refs.form;
        form.validate(function (v) {
        });
    };
    /**
     * 验证数据是否完整
     */
    ConfigBase.prototype.validateExpression = function () {
        var _this = this;
        var rules = {
            relation: { required: true, message: "请选择链接关系符" },
            variable: { required: true, message: "请选择字段" },
            symbol: { required: true, message: "请选择操作符" },
            value: { required: true, message: "缺少期望值" }
        };
        var results = this.strategyDataSet.map(function (v) { return ValidatorService.validate(v, rules); });
        return Promise.all(results)
            .then(function () { return true; })
            .catch(function (_a) {
            var errors = _a.errors;
            if (errors.length)
                _this.$message(errors[0].message);
            return Promise.reject(false);
        });
    };
    ConfigBase.prototype.endDateblur = function (val) {
        if (this.model.startDate && this.model.endDate && this.model.startDate > this.model.endDate) {
            if (val === 1) {
                this.$message('开始日期不能大于结束日期');
                this.model.startDate = '';
            }
            else {
                this.model.endDate = '';
                this.$message('结束日期不能小于开始日期');
            }
            return;
        }
    };
    /**
     * 验证连接符是否完整
     */
    ConfigBase.prototype.validateBreaketComplete = function () {
        if (!this.model.casePoolTypes.length) {
            this.$message('请选择取数案件池!');
            return Promise.reject('Error');
        }
        if (!this.strategyDataSet.length) {
            this.$message('请配置数据规则');
            return Promise.reject('Error');
        }
        var result = this.strategyDataSet.reduce(function (s, c) {
            if (c.leftBracket === '(')
                s += 1;
            if (c.leftBracket === '((')
                s += 2;
            if (c.rightBracket === ')')
                s -= 1;
            if (c.rightBracket === '))')
                s -= 2;
            return s;
        }, 0);
        if (result === 0) {
            return Promise.resolve(true);
        }
        else {
            var message = result > 0 ? '缺少右括号 ）' : '缺少左括号（';
            this.$message(message);
            return Promise.reject('Error');
        }
    };
    ConfigBase.prototype.addNewConfigLine = function () {
        var addFlag = true;
        if (this.strategyDataSet.length) {
            var lastLine = this.strategyDataSet[this.strategyDataSet.length - 1];
            addFlag = !!lastLine.relation;
        }
        if (addFlag) {
            this.strategyDataSet.push({
                relation: "",
                variable: "",
                symbol: "",
                leftBracket: "",
                rightBracket: "",
                value: ""
            });
        }
        else {
            this.$message.warning("请完善数据规则");
        }
    };
    /**
     * 重置
     */
    ConfigBase.prototype.reset = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    /**
     * 预览频次
     */
    ConfigBase.prototype.viewClick = function () {
        this.dateArr = [];
        if (!this.model.startDate) {
            this.$message.warning('请先选择开始时间！');
            return;
        }
        if (!this.model.endDate) {
            this.$message.warning('请先选择结束时间！');
            return;
        }
        if (!this.model.timeType) {
            this.$message.warning('请先选择时间间隔类型！');
            return;
        }
        if (!this.model.intervals) {
            this.$message.warning('请先选择间隔时间！');
            return;
        }
        var ff = this.model.timeType === 'DAY' ? (Number(this.model.intervals) * 24 * 60 * 60 * 1000) : (Number(this.model.intervals) * 60 * 60 * 1000);
        var startDate = new Date(this.model.startDate);
        startDate = startDate.valueOf();
        var endDate = new Date(this.model.endDate);
        endDate = endDate.valueOf();
        if (endDate - startDate < ff) {
            this.showpopover = true;
            this.$message.warning('当前策略执行时间不规范');
            this.model.intervals = '';
        }
        else {
            this.dateArr = FilterService.getAllDate(this.model.startDate, this.model.endDate, this.model.intervals, this.model.timeType);
            this.showpopover = false;
        }
    };
    __decorate([
        Model("base-change", {
            required: true,
            type: Object
        })
    ], ConfigBase.prototype, "model", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ConfigBase.prototype, "disabledData", void 0);
    __decorate([
        Prop({ type: String })
    ], ConfigBase.prototype, "val", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], ConfigBase.prototype, "show", void 0);
    __decorate([
        Emit('base-change')
    ], ConfigBase.prototype, "emitBaseChange", null);
    ConfigBase = __decorate([
        Component({
            components: {
                ExpressionBase: ExpressionBase
            }
        })
    ], ConfigBase);
    return ConfigBase;
}(Vue));
export default ConfigBase;
